import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4122b492"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "new-page-header"
};
const _hoisted_2 = {
  class: "header-content"
};
import { IconClose } from '@xunlei/thunder-icon-vue';
import { isAndroidNative, isHarmonyNative } from '@xunlei/universal-native-api';
import { useEnvStore } from '@remote/store/env';
export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    isCloseShow: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close", "back"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const envStore = useEnvStore();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass({
          'header-padding': true,
          'android-padding': _unref(isAndroidNative),
          'ios-padding': _unref(envStore).isUseIOSHeader,
          'harmony-padding': _unref(isHarmonyNative)
        })
      }, null, 2), _createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
        href: "javascript:;",
        class: "qh-icon-back",
        onClick: _cache[0] || (_cache[0] = $event => emit('back'))
      }), _createElementVNode("h1", null, _toDisplayString(props.title), 1), props.isCloseShow ? (_openBlock(), _createBlock(_unref(IconClose), {
        key: 0,
        width: 26,
        onClick: _cache[1] || (_cache[1] = $event => emit('close'))
      })) : _createCommentVNode("", true)])]);
    };
  }
});